import React from 'react';

import { styled } from 'styled-components';

import { useArticleListingUrl } from 'context/articleListingUrl.context';

import ContentContainer from 'components/ContentContainer/ContentContainer';
import FeaturedArticle from 'components/ModularBlocks/ArticlesBlock/components/FeaturedArticle';
import RecentArticles from 'components/ModularBlocks/ArticlesBlock/components/RecentArticles';

import { useFetchArticles } from 'hooks/queries/useFetchArticles';

import { ArticlesBlockI } from 'interfaces/content-stack/modular-blocks/articlesBlock';

const Header = styled.div`
  font-family: ${(props) => props.theme.fonts.fontFamilySecondary};
  font-size: 3rem;
  text-transform: uppercase;
  margin-bottom: 2rem;

  @media (max-width: ${(props) => props.theme.breakpoints.lg}) {
    font-size: 2.75rem;
  }

  @media (max-width: ${(props) => props.theme.breakpoints.md}) {
    font-size: 2rem;
  }
`;

const Grid = styled.div`
  display: grid;
  gap: 3rem;
  grid-auto-columns: 1fr;
  grid-template-rows: auto;

  grid-template-columns: 2.5fr 1fr;

  @media screen and (min-width: 1440px) {
    grid-template-columns: 2.75fr 1fr;
  }

  @media screen and (min-width: 1920px) {
    grid-template-columns: 3fr 1fr;
  }
`;

const Column = styled.div`
  @media screen and (max-width: ${({ theme }) => theme.breakpoints.lg}) {
    grid-area: span 1 / span 2 / span 1 / span 2;
  }
`;

export interface ArticlesBlockProps {
  className?: string;
  data: ArticlesBlockI;
}

const ArticlesBlock = ({ className, data }: ArticlesBlockProps) => {
  const { showRecentArticles, header, pullFeaturedArticle } = data;
  const { featuredArticle, filteredRecentArticles } = useFetchArticles({ pullFeaturedArticle });
  const { allArticles } = useArticleListingUrl();

  return (
    <ContentContainer className={className} elasticExclude={true}>
      <Header>{header}</Header>
      <Grid>
        <Column>
          <FeaturedArticle article={featuredArticle} />
        </Column>
        <Column>
          {showRecentArticles && <RecentArticles articles={filteredRecentArticles} allArticles={allArticles} />}
        </Column>
      </Grid>
    </ContentContainer>
  );
};

export default ArticlesBlock;
